import React, { useState } from "react";
import { getGroupByName, saveGroup } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import GroupNameField from "./GroupNameField";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function CreateGroupModal({ setShowModal, validationErrors, onBack }) {

    const [group, setGroup] = useState({});

    const onSaveClick = async () => {

        const serverGroup = await getGroupByName(group.name);
        let savedGroup;

        if ((serverGroup.error && serverGroup.statusCode === 404) || serverGroup.id === group.id) {
            savedGroup = await saveGroup(group);
        } else {
            showDangerToast(`Group with name '${group.name}' already exist`, "Save Group")
        }

        if (savedGroup) {
            showSuccessToast("Group created", "Save Group");
            setShowModal(false);
        }


    }

    return (
        <TargetTypeWizardModal
            title="Add Group Wizard"
            subtitle="Create a group target type."
            onClose={() => setShowModal(false)}
            onBack={onBack}
            onSubmit={onSaveClick}
            submitLabel="Save"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <GroupNameField group={group} setGroup={setGroup} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(CreateGroupModal);
